<div class="main_header_div">
  <div class="child">
    <h1 class="header_name ">Export Employee Details</h1>
  </div>
  <div>
    <button class="close-button" (click)="matDialogClose()"><img src="assets/icons/close.png" alt=""></button>
  </div>
</div>
<div class="main_body_div">
  <div class="row body-text-box align-items-center">
    <div class="col-md-12 mt-3">
      <div class="body-text">
        Select the documents to download:
      </div>
    </div>
    <div class="col-md-12">
      <div class="selector mt-4 ">
        <mat-form-field appearance="outline" class="example-full-width">
          <mat-label>
            <img src="/assets/svg/filter-icon.svg" />
            <span class="common-heading"> Select Document Type:</span>
          </mat-label>
          <mat-select [(ngModel)]="docSearch" multiple>
            <mat-option *ngFor="let doc of docArray" [value]="doc">
              <div
                class="options"
                #docum
                [matTooltip]="getFormattedType(doc)"
                [matTooltipPosition]="position.value"
                [matTooltipClass]="position.value"
              >
                {{getFormattedType(doc)}}
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="download-btn-div text-center">
        <button class="download-btn" (click)="onDownload()"  [disabled]="!this.docSearch||this.docSearch.length===0" *ngIf="!this.docSearch||this.docSearch.length===0; else DownloadButtonEnabled"
        [ngClass]="{'dimmed': (!this.docSearch||this.docSearch.length===0)}" >Download</button>

        <ng-template #DownloadButtonEnabled>
          <button class="download-btn" (click)="onDownload()" 
        [ngClass]="{'dimmed': (!this.docSearch||this.docSearch.length===0)}">Download</button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
